import http from '@/services/http'

/**
 * get intercom config
 * @returns Promise<IInterComConfig>
 */
export const getIntercomConfig = () => http.admin.post<IInterComConfig>('/api/intercom/get_config', {})
